import { useCallback } from 'react'

import { Form } from 'brief-form'
import { LeaveConfirmation, Page, PageFace, Panel } from 'ui/components'

import { ContactForm } from '../../types/contact'
import { ContactAddress } from './ContactAddress'
import { ContactDetails } from './ContactDetails'
import { Footer } from './Footer'
import { useContactManage } from './useContactManage'

import * as SC from './styles'

const ContactManage = () => {
  const {
    showBio,
    subTitle,
    isContactFetching,
    isContactFormSaving,
    formData,
    DeleteConfirmation,
    returnUrlForCancel,
    onDelete,
    onSubmit
  } = useContactManage()

  const { config, isDirty, Field } = formData

  const originalChangeHandler = config.onChange

  config.onChange = useCallback(
    (v: ContactForm, e) => {
      if (config.value.country && config.value.country !== v.country) {
        v.state = undefined
        delete e['mailingState']
      }
      originalChangeHandler(v, e)
    },
    [originalChangeHandler, config.value.country]
  )

  return (
    <>
      <DeleteConfirmation />
      <LeaveConfirmation preventLeaving={isDirty && !isContactFormSaving}>
        <Form config={config}>
          <Page
            subTitle={subTitle}
            face={PageFace.SECONDARY}
            isPending={isContactFetching}
            footer={
              <Footer
                onSubmit={onSubmit}
                onDelete={onDelete}
                isSubmitting={isContactFormSaving}
                returnUrl={returnUrlForCancel}
              />
            }
          >
            <Panel title="Contact Information" collapsible={false} rounded shadowed>
              <SC.FormBody>
                <ContactDetails showBio={showBio ?? false} Field={Field} />
                <SC.WrappedHr />
                <ContactAddress Field={Field} config={config} />
              </SC.FormBody>
            </Panel>
          </Page>
        </Form>
      </LeaveConfirmation>
    </>
  )
}

export default ContactManage
